module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "CH-TITLE",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("I")]), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("R")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("U")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("N")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-2 t"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("We always thought of the ’50s as Elvis and the postwar boom; the ’60s as Woodstock, free love, and getting high; and the ’70s as “The Me Decade,” living the good life amid fondue, lava lamps, and disco madness. Now that we’re ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("in")]), _c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v(" our 50s, 60s, and 70s, those numbers mean something else entirely: our age. They also mean Social Security, little aches and pains, and the gateway to our third act. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("But really, things are just beginning to happen. We’re healthier, we live longer than the generations before us; we have later-in-life careers; we go on dating websites; we’re more engaged and travel farther.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Older is getting younger every day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("SO WHO’S COUNTING? is the book that proves it. It’s an acknowledgment and affirmation of our journey, chock-full of inspiration, humor, and reminders that things are just beginning to happen.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("The best is now.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ee8530c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SoWhosCounting_epub_final2.vue
// module id = 66
// module chunks = 0